import { QueryField } from '../../../../../types/QueryBuilder';
import RadioEditor from './RadioEditor';
import CheckboxEditor from './CheckboxEditor';
import SelectEditor from './SelectEditor';
import DateEditor from './DateEditor';
import NumberEditor from './NumberEditor';
import BetweenEditor from './BetweenEditor';
import TextEditor from './TextEditor';

interface ValueEditorProps {
    ruleId: string;
    field?: QueryField;
    operator: string;
    value: any;
    onChange: (value: any) => void;
}

function ValueEditor({ ruleId, field, operator, value, onChange }: ValueEditorProps) {
    if (!field) {
        return (
            <TextEditor
                ruleId={ruleId}
                value={value}
                onChange={onChange}
                placeholder="Sélectionnez d'abord un champ..."
            />
        );
    }

    const { valueEditorType, inputType, values } = field;

    if (operator === 'between') {
        return (
            <BetweenEditor
                ruleId={ruleId}
                value={value}
                inputType={inputType}
                onChange={onChange}
            />
        );
    }

    if ((operator === 'in' || operator === 'not in') && 
        (valueEditorType === 'select' || valueEditorType === 'multiselect')) {
        return (
            <SelectEditor
                ruleId={ruleId}
                value={value}
                values={values || []}
                isMultiSelect={true}
                onChange={onChange}
            />
        );
    }

    if (valueEditorType === 'checkbox') {
        return (
            <CheckboxEditor
                ruleId={ruleId}
                value={value}
                values={values || []}
                onChange={onChange}
            />
        );
    }

    if (valueEditorType === 'select' || valueEditorType === 'multiselect') {
        return (
            <SelectEditor
                ruleId={ruleId}
                value={value}
                values={values || []}
                isMultiSelect={valueEditorType === 'multiselect'}
                onChange={onChange}
            />
        );
    }

    if (valueEditorType === 'radio' && values && values.length > 0) {
        return (
            <RadioEditor
                ruleId={ruleId}
                value={value}
                values={values}
                onChange={onChange}
            />
        );
    }

    if (inputType === 'number') {
        return (
            <NumberEditor
                ruleId={ruleId}
                value={value}
                onChange={onChange}
            />
        );
    }

    if (inputType === 'date') {
        return (
            <DateEditor
                ruleId={ruleId}
                value={value}
                onChange={onChange}
            />
        );
    }

    return (
        <TextEditor
            ruleId={ruleId}
            value={value}
            onChange={onChange}
        />
    );
};

export default ValueEditor;
